export default function abbreviateMileage(num: number): string {
  if (num >= 1000 && num < 10000) {
    const tenthsOfK = Math.ceil(num / 100);
    const value = tenthsOfK / 10;

    return (tenthsOfK % 10 === 0 ? value.toFixed(0) : value.toFixed(1)) + 'k';
  } else if (num > 899) {
    return Math.ceil(num / 1000).toFixed(0) + 'k';
  } else if (num > 89) {
    return (Math.ceil(num / 100) * 100).toFixed(0);
  } else {
    return Math.ceil(num).toFixed(0);
  }
}
